var _defs, _rect, _rect2, _path, _path2, _path3, _path4, _path5, _rect3, _rect4, _path6, _rect5, _rect6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalSchool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#313fc4;}.c{fill:none;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 2.45,
    y: 50.4,
    width: 13.72,
    height: 2.11
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 18.28,
    y: 50.4,
    width: 27.44,
    height: 3.16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m16.17,20.84c-1.17,0-2.11-.94-2.11-2.11h-7.14c-.4,0-.77.23-.94.58l-1.81,3.64h12s0-2.11,0-2.11Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m47.83,22.97h12.01l-1.81-3.64c-.18-.36-.54-.58-.94-.58h-7.14c0,1.17-.94,2.11-2.11,2.11v2.11h-.01Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m42.43,10.61c-.19-.19-.46-.31-.75-.31h-20.3c-.31,0-.6.14-.81.39l-3.2,3.84h28.97l-3.91-3.91h0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m18.28,25.08H3.5v23.22h14.78v-23.22Zm-9.5,18.99c0,.58-.48,1.05-1.05,1.05s-1.05-.48-1.05-1.05v-2.11c0-.58.48-1.05,1.05-1.05s1.05.48,1.05,1.05v2.11Zm0-6.33c0,.58-.48,1.05-1.05,1.05s-1.05-.48-1.05-1.05v-2.11c0-.58.48-1.05,1.05-1.05s1.05.48,1.05,1.05v2.11Zm0-6.33c0,.58-.48,1.05-1.05,1.05s-1.05-.48-1.05-1.05v-2.11c0-.58.48-1.05,1.05-1.05s1.05.48,1.05,1.05v2.11Zm6.33,12.67c0,.58-.48,1.05-1.05,1.05s-1.05-.48-1.05-1.05v-2.11c0-.58.48-1.05,1.05-1.05s1.05.48,1.05,1.05v2.11Zm0-6.33c0,.58-.48,1.05-1.05,1.05s-1.05-.48-1.05-1.05v-2.11c0-.58.48-1.05,1.05-1.05s1.05.48,1.05,1.05v2.11Zm0-6.33c0,.58-.48,1.05-1.05,1.05s-1.05-.48-1.05-1.05v-2.11c0-.58.48-1.05,1.05-1.05s1.05.48,1.05,1.05v2.11Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m43.61,48.29v-23.21h-23.21v23.22h6.33v-12.67c0-.58.48-1.05,1.05-1.05h8.45c.58,0,1.05.48,1.05,1.05v12.67h6.33,0Zm-13.72-17.94c0,.58-.48,1.05-1.05,1.05s-1.05-.48-1.05-1.05v-2.11c0-.58.48-1.05,1.05-1.05s1.05.48,1.05,1.05v2.11Zm6.33,0c0,.58-.48,1.05-1.05,1.05s-1.05-.48-1.05-1.05v-2.11c0-.58.48-1.05,1.05-1.05s1.05.48,1.05,1.05v2.11Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 47.83,
    y: 50.4,
    width: 13.72,
    height: 2.11
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 16.17,
    y: 16.63,
    width: 31.66,
    height: 2.11
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m60.5,25.08h-14.78v23.22h14.78v-23.22Zm-9.5,18.99c0,.58-.48,1.05-1.05,1.05s-1.05-.48-1.05-1.05v-2.11c0-.58.48-1.05,1.05-1.05s1.05.48,1.05,1.05v2.11Zm0-6.33c0,.58-.48,1.05-1.05,1.05s-1.05-.48-1.05-1.05v-2.11c0-.58.48-1.05,1.05-1.05s1.05.48,1.05,1.05v2.11Zm0-6.33c0,.58-.48,1.05-1.05,1.05s-1.05-.48-1.05-1.05v-2.11c0-.58.48-1.05,1.05-1.05s1.05.48,1.05,1.05v2.11Zm6.33,12.67c0,.58-.48,1.05-1.05,1.05s-1.05-.48-1.05-1.05v-2.11c0-.58.48-1.05,1.05-1.05s1.05.48,1.05,1.05v2.11Zm0-6.33c0,.58-.48,1.05-1.05,1.05s-1.05-.48-1.05-1.05v-2.11c0-.58.48-1.05,1.05-1.05s1.05.48,1.05,1.05v2.11Zm0-6.33c0,.58-.48,1.05-1.05,1.05s-1.05-.48-1.05-1.05v-2.11c0-.58.48-1.05,1.05-1.05s1.05.48,1.05,1.05v2.11Z"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 18.28,
    y: 20.84,
    width: 27.44,
    height: 2.11
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 28.84,
    y: 36.67,
    width: 6.33,
    height: 11.61
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m62.61,48.58v-24.56c0-.17-.04-.32-.12-.46h0l-2.58-5.17c-.53-1.08-1.63-1.76-2.83-1.75h-7.14v-1.05c0-.28-.12-.55-.31-.75l-5.71-5.71c-.39-.37-.85-.64-1.36-.78h-22.04c-.6.15-1.14.51-1.56,1l-4.64,5.57c-.15.19-.24.42-.24.68v1.05h-7.15c-1.2,0-2.3.67-2.83,1.75l-2.58,5.14h0c-.08.14-.12.31-.12.48v24.56c-.66.37-1.05,1.07-1.05,1.81v2.11c0,1.17.94,2.11,2.11,2.11h14.02c.37.66,1.07,1.05,1.81,1.05h27.44c.75,0,1.44-.4,1.81-1.05h14.02c1.17,0,2.11-.94,2.11-2.11v-2.11c0-.75-.4-1.44-1.05-1.81Zm-12.67-29.85h7.14c.4,0,.77.23.94.58l1.81,3.64h-12.01v-2.11c1.17,0,2.11-.94,2.11-2.11h.01Zm-29.37-8.06c.21-.24.5-.39.81-.39h20.3c.28,0,.55.12.75.31l3.91,3.91h-28.97l3.2-3.84h0Zm-4.4,5.95h31.66v2.11h-31.66v-2.11Zm20.05,17.94h-8.45c-.58,0-1.05.48-1.05,1.05v12.67h-6.33v-23.21h23.22v23.22h-6.33v-12.67c0-.58-.48-1.05-1.05-1.05h-.01Zm-1.05,2.11v11.61h-6.33v-11.61h6.33Zm-16.88-13.71v-2.11h27.44v2.11h-27.44Zm-12.31-3.64c.18-.36.54-.58.94-.58h7.14c0,1.17.94,2.11,2.11,2.11v2.11H4.16s1.81-3.64,1.81-3.64Zm10.2,33.19H2.45v-2.11h13.72v2.11Zm1.05-4.22H3.5v-23.22h14.78v23.22s-1.05,0-1.05,0Zm28.5,5.27h-27.44v-3.16h27.44v3.16Zm1.05-5.27h-1.05v-23.22h14.78v23.22s-13.72,0-13.72,0Zm14.78,4.22h-13.72v-2.11h13.72v2.11Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m28.84,27.18c-.58,0-1.05.48-1.05,1.05v2.11c0,.58.48,1.05,1.05,1.05s1.05-.48,1.05-1.05v-2.11c0-.58-.48-1.05-1.05-1.05Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m14.06,28.24c-.58,0-1.05.48-1.05,1.05v2.11c0,.58.48,1.05,1.05,1.05s1.05-.48,1.05-1.05v-2.11c0-.58-.48-1.05-1.05-1.05Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m7.73,28.24c-.58,0-1.05.48-1.05,1.05v2.11c0,.58.48,1.05,1.05,1.05s1.05-.48,1.05-1.05v-2.11c0-.58-.48-1.05-1.05-1.05Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m14.06,34.57c-.58,0-1.05.48-1.05,1.05v2.11c0,.58.48,1.05,1.05,1.05s1.05-.48,1.05-1.05v-2.11c0-.58-.48-1.05-1.05-1.05Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m7.73,34.57c-.58,0-1.05.48-1.05,1.05v2.11c0,.58.48,1.05,1.05,1.05s1.05-.48,1.05-1.05v-2.11c0-.58-.48-1.05-1.05-1.05Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m14.06,40.91c-.58,0-1.05.48-1.05,1.05v2.11c0,.58.48,1.05,1.05,1.05s1.05-.48,1.05-1.05v-2.11c0-.58-.48-1.05-1.05-1.05Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m7.73,40.91c-.58,0-1.05.48-1.05,1.05v2.11c0,.58.48,1.05,1.05,1.05s1.05-.48,1.05-1.05v-2.11c0-.58-.48-1.05-1.05-1.05Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m56.28,28.24c-.58,0-1.05.48-1.05,1.05v2.11c0,.58.48,1.05,1.05,1.05s1.05-.48,1.05-1.05v-2.11c0-.58-.48-1.05-1.05-1.05Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m49.94,28.24c-.58,0-1.05.48-1.05,1.05v2.11c0,.58.48,1.05,1.05,1.05s1.05-.48,1.05-1.05v-2.11c0-.58-.48-1.05-1.05-1.05Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m56.28,34.57c-.58,0-1.05.48-1.05,1.05v2.11c0,.58.48,1.05,1.05,1.05s1.05-.48,1.05-1.05v-2.11c0-.58-.48-1.05-1.05-1.05Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m49.94,34.57c-.58,0-1.05.48-1.05,1.05v2.11c0,.58.48,1.05,1.05,1.05s1.05-.48,1.05-1.05v-2.11c0-.58-.48-1.05-1.05-1.05Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m56.28,40.91c-.58,0-1.05.48-1.05,1.05v2.11c0,.58.48,1.05,1.05,1.05s1.05-.48,1.05-1.05v-2.11c0-.58-.48-1.05-1.05-1.05Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m49.94,40.91c-.58,0-1.05.48-1.05,1.05v2.11c0,.58.48,1.05,1.05,1.05s1.05-.48,1.05-1.05v-2.11c0-.58-.48-1.05-1.05-1.05Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m35.16,27.18c-.58,0-1.05.48-1.05,1.05v2.11c0,.58.48,1.05,1.05,1.05s1.05-.48,1.05-1.05v-2.11c0-.58-.48-1.05-1.05-1.05Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalSchool);
export default __webpack_public_path__ + "static/media/totalSchool.2231ecd4b0826b7a89e4814d434579c8.svg";
export { ForwardRef as ReactComponent };